import React, { useState } from "react";
import css from "../../style/onboardingweb.module.css";
import { useParams, useHistory } from "react-router";
import { postDocumentsWeb } from "../../store/actions/onboardingActions";
import { toast } from "react-toastify";
import ErrorComponent from "../../components/ErrorComponent";

const ProofOfWorkEligibility = () => {
  const history = useHistory();
  const { id, type } = useParams();

  const [error, setError] = useState("");
  const [Profile, setProfile] = useState();
  const [ProfileImg, setProfileImg] = useState();
  const [takePhoto, setTakePhoto] = useState(false);

  const handleAddImage = (e) => {
    if (e.target.files?.length) {
      setProfile(e.target.files[0]);
      setProfileImg(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmitForm = () => {
    if (Profile) {
      const formData = new FormData();
      formData.append("workEligibilityProFile", Profile);
      postDocumentsWeb(id, type, formData, setError, history);
    } else {
      toast.error("Please upload your Proof of work eligibility.");
    }
  };
  return (
    <div className={css?.mD}>
      {takePhoto ? (
        <div className={css?.centerDiv}>
          <div className={css?.contentDiv}>
            <label htmlFor="profile-photo">
              <div className={css?.dlUploadMd}>
                <h4 className={css?.l2Heading}>Click below to take photo</h4>
                <div className={css?.dlUploadImgBG}>
                  <img
                    src={ProfileImg ?? "/images/upload.png"}
                    className={ProfileImg ? css?.UploadImg : css?.dlUploadImg}
                  />
                </div>
              </div>
            </label>
            <input
              id="profile-photo"
              name="workEligibilityProFile"
              type="file"
              accept="image/*"
              capture="camera"
              onChange={handleAddImage}
              style={{ display: "none" }}
            />
            <ErrorComponent error={error} />
          </div>
          <div className={css?.buttonPanel}>
            <div className={css?.submitButton} onClick={handleSubmitForm}>
              Confirm
            </div>
          </div>
        </div>
      ) : (
        <div className={css?.centerDiv}>
          <div className={css?.contentDiv}>
            <h3 className={css?.mHeading}>
              Take a photo of your Proof of Work Eligibility
            </h3>
            <div className={css?.mtext}>
              Please upload a current (non-expired) document from the list below
              to verify that you can legally work as an independent contractor
              in Canada: Passport, Residency card, Birth certificate,
              Citizenship card and/or Work permit.
            </div>
            <div className={css?.imageDiv}>
              <img
                src="/images/workEligibilityProFile.png"
                className={css?.weImage}
              />
            </div>
          </div>
          <div className={css?.buttonPanel}>
            <div
              className={css?.submitButton}
              onClick={() => setTakePhoto(true)}
            >
              Take Photo
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProofOfWorkEligibility;
